import { jsonParse } from '@/utils'
import type { ISetting } from './type'

export function settingFormat<T, R>({ dataValue, ...setting }: ISetting) {
  const formateValue = jsonParse<T, R>(dataValue) as R extends string ? Partial<T> : R
  return {
    ...setting,
    dataValue: formateValue,
  }
}
